// usePageView.js
import { useEffect } from 'react';
import ReactGA from 'react-ga';

const useGAPageview = (page) => {
  useEffect(() => {
    if (typeof window !== 'undefined' && window.ga) {
      ReactGA.send('pageview');
    }
  }, [page]);
};

export default useGAPageview;
